import { render, staticRenderFns } from "./CashShopEntryCard.vue?vue&type=template&id=63584a08&scoped=true&"
import script from "./CashShopEntryCard.vue?vue&type=script&lang=ts&"
export * from "./CashShopEntryCard.vue?vue&type=script&lang=ts&"
import style0 from "./CashShopEntryCard.vue?vue&type=style&index=0&id=63584a08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63584a08",
  null
  
)

export default component.exports